function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useDropdownMenu } from '@lwt-helix/useDropdownMenu';
import React, { useRef, useContext, useState, useEffect } from 'react';
import DropdownMenu from './DropdownMenu.js';
import { StyledNavbarNav } from './Navbar.styles.js';
import NavbarBadge from './NavbarBadge.js';
import { NavbarContext } from './NavbarContext.js';
import NavbarDropdownNavItem from './NavbarDropdownNavItem.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { checkIfChildIsA, getTarget, clickDropdownItem } from './NavbarHelpers.js';
import NavbarMenuItem from './NavbarMenuItem.js';
/* eslint-disable max-len */

var NavbarNavigationBar = function NavbarNavigationBar(_ref) {
  var _ref$moreLabel = _ref.moreLabel,
      moreLabel = _ref$moreLabel === void 0 ? 'More' : _ref$moreLabel,
      _ref$navItems = _ref.navItems,
      navItems = _ref$navItems === void 0 ? [] : _ref$navItems,
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? {
    pathname: ''
  } : _ref$location,
      _ref$hideMoreDropdown = _ref.hideMoreDropdownArrow,
      hideMoreDropdownArrow = _ref$hideMoreDropdown === void 0 ? false : _ref$hideMoreDropdown,
      _ref$dataLwtId = _ref.dataLwtId,
      dataLwtId = _ref$dataLwtId === void 0 ? 'navbar-navigation-bar' : _ref$dataLwtId,
      className = _ref.className,
      linkWrapper = _ref.linkWrapper,
      _ref$dropdownsExpande = _ref.dropdownsExpandedByDefault,
      dropdownsExpandedByDefault = _ref$dropdownsExpande === void 0 ? false : _ref$dropdownsExpande;
  var navigationBarRef = useRef({});
  var overflowMenuButton = useRef(null);
  var itemsWrapperRef = useRef({});
  var moreButtonWrapperRef = useRef({});

  var _useContext = useContext(NavbarContext),
      isDark = _useContext.isDark,
      setNavItems = _useContext.setNavItems,
      setLocation = _useContext.setLocation,
      setNavbarLinkWrapper = _useContext.setNavbarLinkWrapper,
      setDropdownsExpandedByDefault = _useContext.setDropdownsExpandedByDefault,
      hasAdditionalNavItems = _useContext.hasAdditionalNavItems;

  var _useState = useState({
    items: navItems,
    overflowItems: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      collections = _useState2[0],
      setCollections = _useState2[1];

  var menuRef = useRef(null);
  var lastItemWidth = useRef(undefined);
  var totalItemsWidth = useRef(0); // flat list of menu items needed for downshift. this same list is needed when selecting by `highlightedIndex`

  var getFlattenedOverflowItems = function getFlattenedOverflowItems() {
    return collections.overflowItems.some(function (item) {
      return item === null || item === void 0 ? void 0 : item.menuItems;
    }) ? collections.overflowItems.reduce(function (acc, val) {
      acc.push(val);

      if (val === null || val === void 0 ? void 0 : val.menuItems) {
        acc.push.apply(acc, _toConsumableArray(val.menuItems));
      }

      return acc;
    }, []) : collections.overflowItems;
  };

  var _useDropdownMenu = useDropdownMenu({
    placement: 'bottom-end',
    items: getFlattenedOverflowItems(),
    itemToString: function itemToString(item) {
      return item.label ? item.label : '';
    },
    resetSelectedItemOnClose: true,
    offset: [0, 8]
  }),
      isOpen = _useDropdownMenu.isOpen,
      getToggleButtonProps = _useDropdownMenu.getToggleButtonProps,
      getMenuProps = _useDropdownMenu.getMenuProps,
      highlightedIndex = _useDropdownMenu.highlightedIndex,
      getItemProps = _useDropdownMenu.getItemProps,
      setReferenceElement = _useDropdownMenu.setReferenceElement,
      setPopperElement = _useDropdownMenu.setPopperElement,
      attributes = _useDropdownMenu.attributes,
      styles = _useDropdownMenu.styles;

  var shiftIntoOverflowItems = function shiftIntoOverflowItems() {
    var _a;

    lastItemWidth.current = getFullWidth((_a = itemsWrapperRef === null || itemsWrapperRef === void 0 ? void 0 : itemsWrapperRef.current) === null || _a === void 0 ? void 0 : _a.lastElementChild);
    var newColl = copyCollections();
    newColl.overflowItems.unshift(newColl.items[newColl.items.length - 1]);
    newColl.items.pop();
    setCollections(newColl);
  };

  var shiftIntoItems = function shiftIntoItems() {
    var _a;

    var newColl = copyCollections();
    newColl.items.push(newColl.overflowItems[0]);
    newColl.overflowItems.shift();
    setCollections(newColl);
    lastItemWidth.current = getFullWidth((_a = itemsWrapperRef === null || itemsWrapperRef === void 0 ? void 0 : itemsWrapperRef.current) === null || _a === void 0 ? void 0 : _a.lastElementChild);
  };

  var copyCollections = function copyCollections() {
    return {
      items: _toConsumableArray(collections.items),
      overflowItems: _toConsumableArray(collections.overflowItems)
    };
  };

  var isOverflowing = function isOverflowing() {
    return navigationBarRef.current && navigationBarRef.current.offsetWidth < navigationBarRef.current.scrollWidth;
  };

  var isUnderflowing = function isUnderflowing() {
    var _a;

    return navigationBarRef.current && totalItemsWidth.current + ((_a = lastItemWidth === null || lastItemWidth === void 0 ? void 0 : lastItemWidth.current) !== null && _a !== void 0 ? _a : 0) < navigationBarRef.current.scrollWidth;
  };

  var updateItems = function updateItems() {
    if (!(navigationBarRef === null || navigationBarRef === void 0 ? void 0 : navigationBarRef.current) || (lastItemWidth === null || lastItemWidth === void 0 ? void 0 : lastItemWidth.current) === 0) {
      return;
    }

    if ((collections === null || collections === void 0 ? void 0 : collections.items.length) > 0 && isOverflowing()) {
      shiftIntoOverflowItems();
    } else if ((collections === null || collections === void 0 ? void 0 : collections.overflowItems.length) > 0 && isUnderflowing()) {
      shiftIntoItems();
    }
  };

  var handleDropdownToggleKeydown = function handleDropdownToggleKeydown(e) {
    var _a;

    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation();
      e.preventDefault();
      var menuItem = getFlattenedOverflowItems()[highlightedIndex];
      menuItem.toggleDropdown = (_a = !menuItem.toggleDropdown) !== null && _a !== void 0 ? _a : true;
    }

    clickDropdownItem(e, menuRef);
  };

  var navItemProps = function navItemProps(navItem) {
    return {
      disabled: navItem.disabled,
      className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? 'helix-unified-nav__navigation-item active' : 'helix-unified-nav__navigation-item'
    };
  };

  var linkWrapperElement = function linkWrapperElement(navItem) {
    var _a, _b;

    return linkWrapper ? (_b = linkWrapper({
      item: navItem,
      props: Object.assign(Object.assign({}, (_a = linkWrapper({
        item: navItem,
        props: navItemProps(navItem)
      })) === null || _a === void 0 ? void 0 : _a.props), {
        disabled: navItem.disabled,
        className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? 'helix-unified-nav__navigation-item active' : 'helix-unified-nav__navigation-item'
      })
    })) === null || _b === void 0 ? void 0 : _b.props.children : React.createElement(React.Fragment, null);
  };

  var getFullWidth = function getFullWidth(element) {
    var _a;

    if (!element || element === null) return undefined;
    var laststyle = window.getComputedStyle(element);
    var margin = parseFloat(laststyle.marginLeft) + parseFloat(laststyle.marginRight);
    var width = ((_a = element.offsetWidth) !== null && _a !== void 0 ? _a : 0) + margin;
    return isNaN(width) ? 0 : width;
  };

  useEffect(function () {
    setNavItems(_toConsumableArray(navItems));
    setCollections({
      items: navItems,
      overflowItems: []
    });
  }, [navItems]);
  useEffect(function () {
    setLocation(location.pathname);
  }, [location]);
  useEffect(function () {
    if (linkWrapper) {
      setNavbarLinkWrapper(function () {
        return linkWrapper;
      });
    }
  }, [linkWrapper]);
  useEffect(function () {
    setDropdownsExpandedByDefault(dropdownsExpandedByDefault);
  }, [dropdownsExpandedByDefault]);
  useEffect(function () {
    var _a;

    var moreButtonSize = (_a = getFullWidth(moreButtonWrapperRef.current)) !== null && _a !== void 0 ? _a : 0;
    totalItemsWidth.current = Array.from(itemsWrapperRef.current.children).map(function (e) {
      var _a;

      return (_a = getFullWidth(e)) !== null && _a !== void 0 ? _a : 0;
    }).reduce(function (acc, curr) {
      return acc + curr;
    }, 0) + moreButtonSize;
    updateItems(); // Limiting the rate of update calls to every 25ms
    // until no resizing has occurred after 100ms

    var timeout;
    var interval = undefined;

    var listener = function listener() {
      // reset timer since window is still resizing
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        // no resizing in the last 100ms so stop periodic update
        clearInterval(interval);
        interval = undefined;
        updateItems();
      }, 100); // call update every 25ms if not started

      !interval && (interval = setInterval(function () {
        return updateItems();
      }, 25));
    };

    window.addEventListener('resize', listener);
    return function () {
      clearTimeout(timeout);
      clearInterval(interval);
      window.removeEventListener('resize', listener);
    };
  }, [collections]);
  return React.createElement(StyledNavbarNav, {
    ref: navigationBarRef,
    isDark: isDark,
    hasAdditionalNavItems: hasAdditionalNavItems,
    hasOverflowItems: collections.overflowItems.length > 0,
    className: "helix-unified-nav__navigation ".concat(className ? className : ''),
    "data-lwt-id": dataLwtId
  }, React.createElement("div", {
    ref: itemsWrapperRef,
    className: 'helix-unified-nav__navigation-items-wrapper'
  }, collections.items.map(function (navItem) {
    var _a, _b;

    return navItem && React.createElement(React.Fragment, {
      key: "nav-bar-item-".concat(navItem.label)
    }, navItem.menuItems ? React.createElement(NavbarDropdownNavItem, {
      location: location,
      linkWrapper: linkWrapper,
      navItem: navItem
    }) : React.createElement(React.Fragment, {
      key: "nav-bar-item-".concat(navItem.label)
    }, navItem.onClick ? React.createElement("button", {
      className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? 'helix-unified-nav__navigation-item active' : 'helix-unified-nav__navigation-item',
      disabled: navItem.disabled,
      onClick: function onClick(e) {
        return navItem.onClick && navItem.onClick(e);
      }
    }, navItem.label, navItem.badge && navItem.badge.label !== undefined && !navItem.badge.hidden && React.createElement(NavbarBadge, {
      isDark: isDark
    }, navItem.badge.label)) : React.createElement(React.Fragment, null, React.createElement(React.Fragment, null, linkWrapper ? React.cloneElement(linkWrapper({
      item: navItem,
      props: {
        disabled: navItem.disabled,
        className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? 'helix-unified-nav__navigation-item active' : 'helix-unified-nav__navigation-item'
      }
    }), {
      disabled: navItem.disabled,
      className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? 'helix-unified-nav__navigation-item active' : 'helix-unified-nav__navigation-item',
      children: checkIfChildIsA(linkWrapper, navItem) ? React.cloneElement(linkWrapperElement(navItem), {
        children: React.createElement(React.Fragment, null, (_b = linkWrapper({
          item: navItem,
          props: Object.assign({}, (_a = linkWrapper({
            item: navItem,
            props: navItemProps(navItem)
          })) === null || _a === void 0 ? void 0 : _a.props)
        })) === null || _b === void 0 ? void 0 : _b.props.children.props.children, navItem.badge && navItem.badge.label !== undefined && !navItem.badge.hidden && React.createElement(NavbarBadge, null, navItem.badge.label))
      }) : React.createElement(React.Fragment, null, linkWrapperElement(navItem), navItem.badge && navItem.badge.label !== undefined && !navItem.badge.hidden && React.createElement(NavbarBadge, null, navItem.badge.label))
    }) : React.createElement("a", Object.assign({
      href: navItem.url,
      key: "nav-bar-item-".concat(navItem.label),
      className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? "helix-unified-nav__navigation-item active ".concat(navItem.disabled ? 'disabled' : '') : "helix-unified-nav__navigation-item ".concat(navItem.disabled ? 'disabled' : ''),
      onClick: function onClick(e) {
        if (navItem.disabled) {
          e.preventDefault();
          return;
        }

        navItem.onClick && navItem.onClick(e);
      }
    }, getTarget(navItem)), navItem.label, navItem.badge && navItem.badge.label && !navItem.badge.hidden && React.createElement(NavbarBadge, {
      isDark: isDark
    }, navItem.badge.label))))));
  })), React.createElement("div", {
    className: 'helix-unified-nav__overflow-button-wrapper',
    ref: function ref(_ref2) {
      moreButtonWrapperRef.current = _ref2;
      setReferenceElement(_ref2);
    }
  }, React.createElement("button", Object.assign({
    className: 'helix-unified-nav__navigation-item helix-unified-nav__navigation-item_more'
  }, getToggleButtonProps({
    ref: overflowMenuButton
  }, {
    suppressRefError: true
  })), moreLabel, !hideMoreDropdownArrow && React.createElement(NavbarHelixIcon, {
    iconName: 'dropdown_open'
  }))), React.createElement(DropdownMenu, Object.assign({
    inNavbar: true,
    maxWidth: '300px',
    ref: setPopperElement,
    isOpen: isOpen && collections.overflowItems.length > 0,
    className: 'helix-unified-nav__overflow-dropdown-menu',
    style: styles.popper
  }, attributes.popper), React.createElement("ul", Object.assign({}, getMenuProps({
    onKeyDown: function onKeyDown(e) {
      return handleDropdownToggleKeydown(e);
    },
    ref: function ref(_ref3) {
      return menuRef.current = _ref3;
    }
  }, {
    suppressRefError: true
  })), isOpen && collections.overflowItems.map(function (overflowItem, index) {
    return React.createElement(NavbarMenuItem, {
      linkWrapper: linkWrapper,
      key: "".concat(overflowItem.label).concat(index),
      menuItem: overflowItem,
      highlightedIndex: highlightedIndex,
      index: index + collections.overflowItems.filter(function (overflowItem, oIndex) {
        return overflowItem.menuItems && oIndex < index;
      }).reduce(function (acc, cur) {
        var _a, _b;

        return acc + ((_b = (_a = cur.menuItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
      }, 0),
      location: location,
      getItemProps: getItemProps
    });
  }))));
};

NavbarNavigationBar.displayName = 'NavbarNavigationBar';
export { NavbarNavigationBar as default };